module.exports = __webpack_public_path__ + "static/img/phone2.238af434.png";